__webpack_require__.p = "https://cdn.inflearn.com/monolith/inflearn-next-frontend/_next/";